/* eslint-disable */
import React from "react";

export default class Health extends React.Component {
    render() {
        return <div>I'm alive</div>
    }
}



// WEBPACK FOOTER //
// client/pages/index2.js